import React from 'react';
import { KeyRound } from 'lucide-react';

/**
 * A quiet note above a table grid whose table has no primary key (owner,
 * 30.09.2026, DataGrip-style editing with a safety rule): rows are matched by
 * their values, and every edit or delete touches exactly one row
 * (dbGridSql.exactOneRow). A hint, not a warning — editing still works.
 *
 * Shown only once the table's metadata has loaded (columns known, no key), so
 * it never flashes while the key is still being looked up.
 */
export default function DbNoKeyNote({ show }) {
  if (!show) return null;
  return (
    <div className="dbm-nokey-note" role="note">
      <KeyRound size={12} aria-hidden />
      <span>No primary key — rows are matched by their values. Each edit or delete changes exactly one row.</span>
    </div>
  );
}
